import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { autoRedirect } from '@/utils/auto_redirect'
import { Bridge } from '@mc/mc-jsbridge'
import { miniProgramEnv, platform } from '@/defines/environment'
import { isMallApp } from '@mc/mc-base-env/src/web/platform'
import Url from '@mc/mc-utils/js/url/url'
import { Dialog } from 'vant'
import { mpsCombination } from '@/utils/native_interactions/mps_combination'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { THEME_COLOR } from '@/defines/environment/config'

export const cmsRedirect = data => {
  if (data?.payload) {
    const { payload, tickerInfo, type } = data
    if (tickerInfo?.click) {
      tracerVuePlugin.click(
        tickerInfo.click.spm,
        Object.assign({}, tickerInfo.click.spmJson, tickerInfo.data)
      )
    }

    // 1、【路由拦截】处理版本升级
    // eslint-disable-next-line camelcase
    const { app_version, support_version } = new Url(payload).parseQuerystring()
    // eslint-disable-next-line camelcase
    if (support_version > app_version) {
      if (isMallApp()) {
        const hasNativeMethod = Bridge.hasNativeMethod('mcsc.updateAppVersion')
        if (hasNativeMethod) {
          Bridge.call('mcsc.updateAppVersion')
        }
        return
      }

      if (miniProgramEnv.isMiniProgram) {
        return Dialog.alert({
          message: '当前版本不支持该功能，请升级小程序~',
          confirmButtonText: '知道了',
          confirmButtonColor: THEME_COLOR
        })
      }
    }

    // 2、【路由拦截】处理类型为 4 的跳转
    // 小程序环境
    if (type === 4 && miniProgramEnv.isMiniProgram) {
      const path = payload.slice(payload.indexOf('#') + 1)
      return mpsCombination.navigateTo({
        url: /^plugin-private:\/\/[\s\S]+$/.test(path) ? path : '/' + path
      })
    }
    // APP 环境
    if (type === 4 && isMallApp()) {
      return Bridge.navigateTo(data?.payload, {})
    }

    const [path, hash] = payload.split('#')

    // 兼容安卓端[!TODO: 待合适时机删除]
    // 原因：由于安卓端优惠券原生路由没有对spm参数做处理，导致无法跳转（但是其他路由也需要spm值）
    // 兼容开始时间：2020.06.04
    // 兼容安卓端本：2.21
    const pathNoQuery = path.split('?')[0]
    const queryWithNoSpm =
      platform === 'android' &&
      pathNoQuery.indexOf(nativeRoutes.myCoupons.app) > -1

    if (tickerInfo?.click && !queryWithNoSpm) {
      const pathWithedTickQuery = `${path}${
        path.indexOf('?') > -1 ? '&' : '?'
      }spm=${tickerInfo.click.spm}`
      const finalUrl = `${pathWithedTickQuery}${hash ? '#' + hash : ''}`
      autoRedirect(finalUrl)
    } else {
      autoRedirect(payload)
    }
  }
}
